export default __webpack_public_path__ + "static/media/customerservice.bb689df5.svg";